import { CalcV100Action, CalcV100State } from 'src/modules/user-input/calcV100/types.ts';
import { convert } from 'src/modules/user-input/convert.ts';
import { initialState } from 'src/modules/user-input/calcV100/initialState.ts';

export const reducer = (prevState: CalcV100State, action: CalcV100Action): CalcV100State => {
    let newState = { ...prevState };
    if (action.type === 'mediumParams_change') {
        newState = {
            ...newState,
            ...action.payload,
        };
    }
    if (action.type === 'ratedCapacity_change') {
        newState = {
            ...newState,
            ratedCapacity: action.payload,
        };
    }
    if (action.type === 'temperatureDifference_change') {
        newState = {
            ...newState,
            temperatureDifference: action.payload,
        };
    }
    if (action.type === 'temperatureDifferenceAir_change') {
        newState = {
            ...newState,
            temperatureDifferenceAir: action.payload,
        };
    }
    if (action.type === 'airflowVolume_change') {
        newState = {
            ...newState,
            airflowVolume: action.payload,
        };
    }
    if (action.type === 'airflowVolume_unit') {
        newState = {
            ...newState,
            airflowVolume: convert(
                newState.airflowVolume,
                newState.airflowVolumeUnit,
                action.payload,
            ),
            airflowVolumeUnit: action.payload,
        };
    }
    if (action.type === 'temperatureDifference_unit') {
        newState = {
            ...newState,
            temperatureDifference: convert(
                newState.temperatureDifference,
                newState.temperatureDifferenceUnit,
                action.payload,
            ),
            temperatureDifferenceUnit: action.payload,
        };
    }
    if (action.type === 'temperatureDifferenceAir_unit') {
        newState = {
            ...newState,
            temperatureDifferenceAir: convert(
                newState.temperatureDifferenceAir,
                newState.temperatureDifferenceAirUnit,
                action.payload,
            ),
            temperatureDifferenceAirUnit: action.payload,
        };
    }
    if (action.type === 'ratedCapacity_unit') {
        newState = {
            ...newState,
            ratedCapacity: convert(
                newState.ratedCapacity,
                newState.ratedCapacityUnit,
                action.payload,
            ),
            ratedCapacityUnit: action.payload,
        };
    }
    if (action.type === 'reset') {
        newState = {
            ...initialState,
        };
    }

    return newState;
};
